
export const DISBURSEMENT_FILTER_PAYMENT_FORMAT = [
    // {
    //     "label": "All Status",
    //     "value": "10",
    //     "defaultChecked": true,
    //     "checked": true,
    //     "_id": "payment1"
    // },
    {
        "label": "Partial Paid",
        "value": "1",
        "defaultChecked": true,
        "checked": true,
        "_id": "payment2"
    },
    {
        "label": "Pending",
        "value": "0",
        "defaultChecked": true,
        "checked": true,
        "_id": "payment3"
    },
    {
        "label": "Paid",
        "value": "2",
        "defaultChecked": true,
        "checked": true,
        "_id": "payment4"
    },
]